import React, { Component } from 'react';
import { Link } from "react-router-dom";
import CookieConsent from "react-cookie-consent";
import {BrowserRouter as Router, Route } from 'react-router-dom';
import asset5 from "./assets/media/images/Titles/talalkozzunk.png";
import back_btn from "./assets/media/newicons/back.png";

import {
  MDBNavbar,
  MDBContainer,
  MDBNavbarBrand,
  MDBNavbarToggler,
  MDBCollapse,
  MDBNav,
  MDBNavbarNav,
  MDBSideNav,
  MDBNavItem,
  MDBNavLink,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBFormInline,
  MDBInputGroup,
  MDBIcon,
  MDBRow,
  MDBCol,
  MDBBadge,
  MDBCard
} from 'mdbreact';

class NavbarComponent extends Component {

	constructor(props) {
    super(props);
    let urlstart = window.location.href;
    if(urlstart.includes('ProgramokBaj')){
      this.state = {
  								  activeItem: "1"
                  };
    }
    if(urlstart.includes('ProgramokSzarliget')){
      this.state = {
  								  activeItem: "2"
                  };
    }
    if(urlstart.includes('ProgramokTata')){
      this.state = {
  								  activeItem: "3"
                  };
    }
    if(urlstart.includes('ProgramokTatabanya')){
      this.state = {
  								  activeItem: "4"
                  };
    }
    if(urlstart.includes('ProgramokVertesszolos')){
      this.state = {
  								  activeItem: "5"
                  };
    }


  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }
  toggle = tab => e => {
    if (this.state.activeItem !== tab) {
      this.setState({
        activeItem: tab});
    }
  }


	render() {
    let url = window.location.href;
		return (
			<>
      <MDBNavbar expand='md' fixed='top' transparent >
				<MDBContainer className="navbarcomponent-nav-container">
        <MDBRow className="m-0 pl-3">
          <MDBNavbarBrand href='/'>
            <MDBRow className="navbrand-row">
              <MDBCol middle md="4" className="text-right pl-0 pr-2">
                <MDBRow end className="m-0 p-0">
                <Link flat to="/"><img className="back-btn" src={back_btn}></img></Link>
                </MDBRow>
              </MDBCol>
              <MDBCol middle md="8" className="text-left p-0">
                <MDBRow start className="m-0">
                <Link flat to="/"><span className="back-text text-capitalize">Vissza</span></Link>
                </MDBRow>
              </MDBCol>
            </MDBRow>
          </MDBNavbarBrand>
          <MDBNavbarNav className="navbarcomponent-nav">
            <MDBNavItem active={url.includes('ProgramokBaj')}>
              <MDBNavLink link to="/ProgramokBaj" active={this.state.activeItem === "1"} onClick={this.toggle("1")} role="tab" ><span className="navbar-text bajNav">BAJ</span></MDBNavLink>
            </MDBNavItem>
            <MDBNavItem active={url.includes('ProgramokSzarliget')}>
              <MDBNavLink link to="/ProgramokSzarliget" active={this.state.activeItem === "2"} onClick={this.toggle("2")} role="tab" ><span className="navbar-text szarligetNav">SZÁRLIGET</span></MDBNavLink>
            </MDBNavItem>
            <MDBNavItem active={url.includes('ProgramokTata')}>
              <MDBNavLink link to="/ProgramokTata" active={this.state.activeItem === "3"} onClick={this.toggle("3")} role="tab" ><span className="navbar-text tataNav">TATA</span></MDBNavLink>
            </MDBNavItem>
            <MDBNavItem active={url.includes('ProgramokTatabanya')}>
              <MDBNavLink link to="/ProgramokTatabanya" active={this.state.activeItem === "4"} onClick={this.toggle("4")} role="tab" ><span className="navbar-text tatabanyaNav">TATABÁNYA</span></MDBNavLink>
            </MDBNavItem>
            <MDBNavItem active={url.includes('ProgramokVertesszolos')}>
              <MDBNavLink link to="/ProgramokVertesszolos" active={this.state.activeItem === "5"} onClick={this.toggle("5")} role="tab" ><span className="navbar-text vertesszolosNav">VÉRTESSZŐLŐS</span></MDBNavLink>
            </MDBNavItem>
					</MDBNavbarNav>
        </MDBRow>
				</MDBContainer>
			</MDBNavbar>
      </>
		);
	}
}

export default NavbarComponent;
